import { createElement } from '@/utils/dom'
import { router } from '@/utils/router'

export class Footer {
  render(): HTMLElement {
    const footer = createElement('footer', { className: 'site-footer' })

    footer.innerHTML = `
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <div class="footer-brand">
              <h3>🗺️ Mapas KM</h3>
              <p>Simulador inteligente de rotas empresariais para empresas portuguesas</p>
            </div>
          </div>
          
          <div class="footer-section">
            <h4>Produto</h4>
            <ul class="footer-links">
              <li><a href="/funcionalidades" class="footer-link">Funcionalidades</a></li>
              <li><a href="/pricing" class="footer-link">Preços</a></li>
              <li><a href="/register" class="footer-link">Começar Grátis</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Suporte</h4>
            <ul class="footer-links">
              <li><a href="mailto:geral@mapakms.com" class="footer-link">Email de Suporte</a></li>
              <li><a href="#" class="footer-link">Tutoriais</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Legal</h4>
            <ul class="footer-links">
              <li><a href="/termos-de-uso" class="footer-link">Termos de Uso</a></li>
              <li><a href="/politica-de-privacidade" class="footer-link">Política de Privacidade</a></li>
              <li><a href="/rgpd" class="footer-link">RGPD</a></li>
              <li><a href="#" class="footer-link cookie-settings-link">Definições de Cookies</a></li>
            </ul>
          </div>
        </div>
        
        <div class="footer-bottom">
          <div class="footer-bottom-content">
            <p>&copy; 2025 Mapas KM. Todos os direitos reservados.</p>
            <div class="footer-note">
              <small>
                <strong>Nota:</strong> Este simulador deve ser usado como ferramenta de apoio para análise de padrões de viagem. 
                Todas as simulações devem ser validadas com dados reais das deslocações efetivamente realizadas.
              </small>
            </div>
          </div>
        </div>
      </div>
    `

    // Add click handlers for internal navigation
    footer.addEventListener('click', (e) => {
      const target = e.target as HTMLElement

      if (target.tagName === 'A' && target.classList.contains('footer-link')) {
        const href = target.getAttribute('href')

        // Handle cookie settings link
        if (target.classList.contains('cookie-settings-link')) {
          e.preventDefault()
          // Trigger cookie settings modal
          const event = new CustomEvent('show-cookie-settings')
          document.dispatchEvent(event)
          return
        }

        // Handle internal navigation links
        if (href === '/funcionalidades' || href === '/pricing' || href === '/register' ||
          href === '/termos-de-uso' || href === '/politica-de-privacidade' || href === '/rgpd') {
          e.preventDefault()
          router.navigate(href)
          return
        }

        // External links (mailto, etc.) will work normally
        if (href?.startsWith('mailto:')) {
          window.location.href = href
          return
        }
      }
    })

    return footer
  }
}
